/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, mergeClasses } from '@fluentui/react-components';

import { useCellSectionDecoratorStyle } from '../styles/tiles-grid-cell-selection-decorator-style';

export const TilesGridCellSelectionDecorator = ({
  item, selected, onClick, children, ariaLabel, isFocused, classes,
}) => {
  const onClickFunc = (event) => {
    if (onClick) {
      onClick({ item, selected });
    }
    if (event.stopPropagation) { event.stopPropagation(); }
    if (event.preventDefault) { event.preventDefault(); }
  };

  const onKeyDown = (event) => {
    if (event.keyCode === 13) { // Enter key
      onClickFunc(event);
    }
  };

  const cellSelectionDecoratorWrapper = useCellSectionDecoratorStyle();

  return (
    <div className={mergeClasses(
      classes.cellSelectionDecoratorWrapper,
      cellSelectionDecoratorWrapper,
      'grid-cell-selection-decorator-wrapper',
      selected && classes.selectedStateWrapper,
      selected ? 'selectedStateWrapper' : ''
    )}
    >
      <div
        className={mergeClasses(classes.cellSelectionDecorator, 'grid-cell-selection-decorator', selected && classes.selectedState, selected ? 'selectedState' : '')}
        onClick={onClickFunc}
        role="button"
        tabIndex={0}
        onKeyDown={onKeyDown}
      >
        {children}
      </div>
      <div
        className={mergeClasses('selected-checkbox', isFocused && 'visible-checkbox')}
        onClick={onClickFunc}
      >
        <Checkbox
          checked={selected}
          ariaLabel={ariaLabel}
          className="checkbox"
        />
      </div>
    </div>
  );
};

TilesGridCellSelectionDecorator.propTypes = {
  item: PropTypes.shape({}).isRequired,
  selected: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  classes: PropTypes.shape({
    cellSelectionDecorator: PropTypes.string,
    cellSelectionDecoratorWrapper: PropTypes.string,
    selectedState: PropTypes.string,
    selectedStateWrapper: PropTypes.string,
  }),
  ariaLabel: PropTypes.string,
  isFocused: PropTypes.bool,
};

TilesGridCellSelectionDecorator.defaultProps = {
  onClick: undefined,
  ariaLabel: '',
  isFocused: false,
  classes: {},
};
